// eslint-disable-next-line import/prefer-default-export
export const appId = 'niw9i7e2';



// WEBPACK FOOTER //
// ./src/const.js